import { get } from 'lodash';

export const shouldDisplayGrantRevokeButtonsSelector = (state) => state.emrManagerReducer.fetchGrantRevokeEmrManagerRoleButtons.shouldDisplay;

export const fetchGrantRevokeEmrManagerRoleButtonsLoadingSelector = (state) => state.emrManagerReducer.fetchGrantRevokeEmrManagerRoleButtons.loading;

export const fetchGrantRevokeEmrManagerRoleButtonsErrorSelector = (state) => state.emrManagerReducer.fetchGrantRevokeEmrManagerRoleButtons.error;

export const hasEmrManagerRoleSelector = (state, { adminId }) => get(state, `emrManagerReducer.admins[${adminId}].hasEmrManagerRole`);

export const grantEmrManagerRoleLoadingSelector = (state, { adminId }) => get(state, `emrManagerReducer.admins[${adminId}].grantEmrManagerRole.loading`);

export const grantEmrManagerRoleErrorSelector = (state, { adminId }) => get(state, `emrManagerReducer.admins[${adminId}].grantEmrManagerRole.error`);

export const revokeEmrManagerRoleLoadingSelector = (state, { adminId }) => get(state, `emrManagerReducer.admins[${adminId}].revokeEmrManagerRole.loading`);

export const revokeEmrManagerRoleErrorSelector = (state, { adminId }) => get(state, `emrManagerReducer.admins[${adminId}].revokeEmrManagerRole.error`);
